<template>
  <div id="app">

    <router-view/>

  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
@import 'normalize.css';

:root {
  --black:  #1d242a;
  --white:  #fcfffc;
  --green:  #06d6a0;
  --red:    #ef476f;
  --yellow: #ffd166;
  --blue:   #48c6ff;

  --yellow-dark: #e8be5d;
}

* { box-sizing: border-box; }

html {  overflow: hidden; }

#app {
  font-family: 'Roboto', sans-serif;
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f3f3f3;
  display: flex;
  line-height: 1.5;
}

.card {
  width: 90%;
  margin: 50px auto;
  background: white;
  border-radius: 5px;
  padding: 5px;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),
    0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);
}

/* #app div {display: flex; } */

</style>
